export const services = [
  {
    id: 1,
    title: 'Policy Research & Analysis',
    icon: 'research',
    shortDescription: 'Comprehensive research and sectoral analysis delivering actionable insights.',
    description: 'We conduct comprehensive research and sectoral analysis, delivering actionable insights into complex policy landscapes. Our approach includes regulatory assessments, risk analysis, and strategic forecasting to inform robust, future-ready decision-making.',
    benefits: [
      'Evidence-based policy formulation',
      'Regulatory assessments and risk analysis',
      'Strategic forecasting and planning',
      'Practical implementation frameworks',
      'Comprehensive policy landscape mapping'
    ]
  },
  {
    id: 2,
    title: 'CSR Impact Evaluation',
    icon: 'impact',
    shortDescription: 'Systematic evaluation of Corporate Social Responsibility initiatives.',
    description: 'Systematic evaluation of Corporate Social Responsibility initiatives to measure effectiveness, identify improvement opportunities, and maximize social return on investment.',
    benefits: [
      'CSR program assessment and audit',
      'Impact measurement frameworks',
      'Stakeholder engagement evaluation',
      'ROI and social return analysis',
      'Strategic improvement recommendations'
    ]
  },
  {
    id: 3,
    title: 'ESG Evaluation and Rating',
    icon: 'monitoring',
    shortDescription: 'Comprehensive ESG reporting and ratings for sustainability assessment.',
    description: 'We provide comprehensive ESG reporting and ratings to help organizations assess their environmental, social, and governance performance. Using trusted methodologies and publicly available data, we deliver objective insights that support better financial decisions, enhance transparency, and align with long-term sustainability goals.',
    benefits: [
      'Comprehensive ESG performance assessment',
      'Objective ratings using trusted methodologies',
      'Financial decision support insights',
      'Transparency enhancement tools',
      'Long-term sustainability alignment'
    ]
  },
  {
    id: 4,
    title: 'Philanthropic Program Assessment',
    icon: 'program',
    shortDescription: 'Comprehensive evaluation of philanthropic funds and programs.',
    description: 'Comprehensive evaluation of philanthropic funds and programs to ensure optimal resource allocation and maximum community benefit.',
    benefits: [
      'Grant program effectiveness review',
      'Beneficiary impact assessment',
      'Resource allocation optimization',
      'Program sustainability analysis',
      'Donor reporting and transparency support'
    ]
  },
  {
    id: 5,
    title: 'Government Project Evaluation',
    icon: 'strategy',
    shortDescription: 'Independent evaluation of government projects and initiatives.',
    description: 'Independent evaluation and analysis of government projects and initiatives to assess effectiveness, efficiency, and social impact.',
    benefits: [
      'Project performance evaluation',
      'Cost-benefit analysis',
      'Stakeholder impact assessment',
      'Implementation gap analysis',
      'Policy recommendation reports'
    ]
  },
  {
    id: 6,
    title: 'Project Management Services',
    icon: 'capacity',
    shortDescription: 'End-to-end management for social initiatives and programs.',
    description: 'We offer end-to-end management for social initiatives, from program design to execution. Services include strategic planning, risk management, stakeholder coordination, progress monitoring, and evaluation for timely, within-budget, and effective project completion.',
    benefits: [
      'Project planning and design',
      'Implementation management',
      'Risk assessment and mitigation',
      'Progress monitoring and reporting',
      'Stakeholder coordination'
    ]
  },
  {
    id: 7,
    title: 'Monitoring & Evaluation (M&E)',
    icon: 'monitoring',
    shortDescription: 'Robust M&E frameworks and reporting tools for impact measurement.',
    description: 'Insocia develops robust monitoring and evaluation frameworks and reporting tools. We support organizations in real-time progress tracking, impact assessment, adjustment for learning, and evidence-based program improvement.',
    benefits: [
      'M&E framework design',
      'Data collection systems',
      'Impact measurement tools',
      'Progress tracking dashboards',
      'Evaluation reports and insights'
    ]
  },
  {
    id: 8,
    title: 'Social Impact Research',
    icon: 'research',
    shortDescription: 'Rigorous social research and impact measurement services.',
    description: 'Rigorous social research and impact measurement services that provide evidence-based insights for informed decision-making. Our Insocia FR service specializes in conducting immersive, field-based research across communities and geographies. Insocia GR offers comprehensive ground-level research using tailored methodologies adapted to the project context.',
    benefits: [
      'Baseline and endline studies',
      'Social impact assessments',
      'Community needs analysis',
      'Behavioral change research',
      'Impact measurement methodologies'
    ]
  },
  {
    id: 9,
    title: 'Advocacy & Policy Development',
    icon: 'strategy',
    shortDescription: 'Strategic advocacy campaigns and policy reform initiatives.',
    description: 'Insocia crafts strategies and campaigns that advance social causes and drive policy reform. We provide advocacy roadmap development, policy briefs, coalition building, stakeholder engagement plans, and execution support for systemic change.',
    benefits: [
      'Advocacy strategy development',
      'Policy brief creation',
      'Stakeholder engagement plans',
      'Campaign design and implementation',
      'Coalition building support'
    ]
  }
]; 